
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export interface UserTransaction {
  id: string;
  project_id: string;
  transaction_type: string;
  quantity: number;
  price_per_credit: number;
  total_amount: number;
  status: string;
  buyer_id?: string;
  seller_id?: string;
  blockchain_tx_hash?: string;
  metadata?: any;
  created_at: string;
  completed_at?: string;
}

export const useTransactions = () => {
  const [transactions, setTransactions] = useState<UserTransaction[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { toast } = useToast();

  const getUserTransactions = async (userId: string) => {
    if (!userId) {
      setTransactions([]);
      return [];
    }

    setLoading(true);
    setError(null);

    try {
      const { data, error } = await supabase
        .from('credit_transactions')
        .select('*')
        .or(`buyer_id.eq.${userId},seller_id.eq.${userId}`)
        .order('created_at', { ascending: false });

      if (error) {
        throw error;
      }

      const userTransactions = data || [];
      setTransactions(userTransactions);
      return userTransactions;
    } catch (err: any) {
      console.error('Error fetching user transactions:', err);
      setError(err.message);
      toast({
        title: "Error",
        description: "Failed to fetch your transactions",
        variant: "destructive"
      });
      return [];
    } finally {
      setLoading(false);
    }
  };

  return { 
    transactions, 
    loading, 
    error, 
    getUserTransactions 
  };
};
